const LABELS = {
  en: {
    home: "Home",
    services: "Services",
    serviceAreas: "Service Areas",
    cityEyebrow: "Residential & Light Commercial Plumbing",
    serviceEyebrow: "Plumbing Service in Hampton Roads, VA",
    neighborhoods: (city) => `Neighborhoods We Serve in ${city}`,
    servicesIn: (city) => `Plumbing Services in ${city}, VA`,
    servicesInText: (city) => `Pellon Morel Solutions provides the following residential and light commercial plumbing services in ${city} and the surrounding Hampton Roads area:`,
    commonProblems: "Common Problems We Solve",
    whatInvolves: "What the Service Involves",
    signs: "Signs You May Need This Service",
    whyProfessional: "Why Professional Diagnosis Matters",
    areasServed: "Areas We Serve in Hampton Roads",
    areasServedText: "This service is available for homes and small businesses throughout Hampton Roads, Virginia, including:",
    faq: "Frequently Asked Questions",
    relatedServices: "Related Plumbing Services",
    popularServices: (city) => `Popular Services in ${city}`,
    nearbyAreas: "Nearby Service Areas",
    ctaBandCity: (city) => `Need a plumber in ${city}?`,
    ctaBandService: "Ready to get it fixed?",
    ctaBandText: "Request a free estimate online, schedule service, or call our bilingual team. We serve all of Hampton Roads, VA.",
    allOfHamptonRoads: "and all of Hampton Roads, VA",
    step: "Step",
  },
  es: {
    home: "Inicio",
    services: "Servicios",
    serviceAreas: "Áreas de Servicio",
    cityEyebrow: "Plomería Residencial y Comercial Ligera",
    serviceEyebrow: "Servicio de Plomería en Hampton Roads, VA",
    neighborhoods: (city) => `Vecindarios que Atendemos en ${city}`,
    servicesIn: (city) => `Servicios de Plomería en ${city}, VA`,
    servicesInText: (city) => `Pellon Morel Solutions ofrece los siguientes servicios de plomería residencial y comercial ligera en ${city} y las áreas cercanas de Hampton Roads:`,
    commonProblems: "Problemas Comunes que Resolvemos",
    whatInvolves: "En Qué Consiste el Servicio",
    signs: "Señales de que Puede Necesitar este Servicio",
    whyProfessional: "Por Qué Importa un Diagnóstico Profesional",
    areasServed: "Áreas que Atendemos en Hampton Roads",
    areasServedText: "Este servicio está disponible para casas y pequeños negocios en todo Hampton Roads, Virginia, incluyendo:",
    faq: "Preguntas Frecuentes",
    relatedServices: "Servicios de Plomería Relacionados",
    popularServices: (city) => `Servicios Populares en ${city}`,
    nearbyAreas: "Áreas de Servicio Cercanas",
    ctaBandCity: (city) => `¿Necesita un plomero en ${city}?`,
    ctaBandService: "¿Listo para resolverlo?",
    ctaBandText: "Solicite un estimado gratis en línea, agende servicio o llame a nuestro equipo bilingüe. Atendemos todo Hampton Roads, VA.",
    allOfHamptonRoads: "y todo Hampton Roads, VA",
    step: "Paso",
  },
};

module.exports = { LABELS };
